const translations = {
    // Product Family related
    productFamilies: "משפחות מוצר",
    deleteProductFamilyConfirm: "אתה בטוח שברצונך למחוק משפחת מוצר זו?",
    productFamilyDeletedSuccess: "משפחת המוצר נמחק בהצלחה",
    productFamilyUpdateSuccess: "משפחת המוצר עודכנה בהצלחה",
    productFamilyUpdateError: "ארעה שגיאה בעדכון משפחת המוצר",
    error: "ארעה שגיאה",

    // Table Headers
    name: "שם",
    description: "תיאור",
    familyType: "טיפוס משפחה",
    orderApprovalRequired: "נדרש אישור הזמנה",
    approvalGroup: "קבוצה הרשאה לאישור הזמנה",

    // Actions
    edit: "עריכה",
    deleteProductFamily: "מחק משפחת מוצר",
    
    // Boolean values
    yes: "כן",
    no: "לא"
};

export default translations;